
<style>
</style>
<template>
  <div class="page-con">
    <div class="list-box common-shadow">
      <vxe-table
        class="table-style"
        border
        highlight-hover-row
        max-height="400"
        :data="tableData"
        @cell-click="cellClickEvent"
      >
        <vxe-table-column field="checkbox" width="55" align="center">
          <template v-slot:header>
            <div>
              <vxe-checkbox></vxe-checkbox>
            </div>
          </template>
          <template v-slot="{row}">
            <vxe-checkbox v-model="row.select"></vxe-checkbox>
          </template>
        </vxe-table-column>
        <vxe-table-column field="id" title="序号" width="55" align="center"></vxe-table-column>
        <vxe-table-column field="invoiceNum" title="发票编号" width="130"></vxe-table-column>
        <vxe-table-column field="addTime" title="开票日期" width="150"></vxe-table-column>
        <vxe-table-column field="invoiceType" title="发票类型" width="80"></vxe-table-column>
        <vxe-table-column field="unit" title="开票单位" width="200"></vxe-table-column>
        <vxe-table-column field="invoiceTitle" title="发票抬头" width="200"></vxe-table-column>
        <vxe-table-column field="goodsName" title="应税商品名称" width="150"></vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="75"></vxe-table-column>
        <vxe-table-column field="unit" title="单位" width="75"></vxe-table-column>
        <vxe-table-column field="price" title="不含税单价(元)" width="150"></vxe-table-column>
        <vxe-table-column field="taxRate" title="税率(%)" width="80"></vxe-table-column>
        <vxe-table-column field="amount" title="价税合计(元)" width="150"></vxe-table-column>
        <vxe-table-column field="note" title="备注信息" width="180"></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="90"></vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="120"></vxe-table-column>
        <vxe-table-column field="endPlace" title="目的地" width="110"></vxe-table-column>
        <vxe-table-column field="laydays" title="受载/交接日期" width="140"></vxe-table-column>
        <vxe-table-column field="chainNum" title="主订单编号" width="130"></vxe-table-column>
        <vxe-table-column field="orderNum" title="子订单编号" width="120"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="120"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="150"></vxe-table-column>
      </vxe-table>
      <div class="add-btn-box">
        <Button type="default" @click="cancelEvent">取消</Button>
        <Button status="primary" @click="submitEvent">提交</Button>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";

export default {
  name: "ChooseInvoice",
  props: {
    cate: {
      type: String,
      default: "", //销项Sales  进项Income
    },
  },
  data() {
    return {
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      let params = {
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
      };
      let res;
      if (this.cate == "Sales") {
        res = await $api.invoice.request("queryInvoiceSellerList", params);
      } else {
        res = await $api.invoice.request("queryInvoiceBuyerList", params);
      }
      if (res.status == 1) {
        let pageData = res.data;
        this.page.currentPage = pageData.pageNum;
        this.page.pageSize = pageData.pageSize;
        this.page.total = pageData.total;
        this.tableData = pageData.rows;
        this.tableData.forEach((item) => {
          item.select = false;
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cellClickEvent(e) {
      let row = e.row;
    },
    submitEvent() {
      let chooseList = [];
      this.tableData.forEach((item) => {
        if (item.select) {
          chooseList.push(item);
        }
      });
      this.$emit("choose", chooseList);
      console.log(chooseList);
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
  },
};
</script>
